/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { ProductType } from "./ProductType";
import { ProductionMaterialType } from "./ProductionMaterialType";
import { DrawableObjectDto } from "./DrawableObjectDto";
import { TextureMaterialDto } from "./TextureMaterialDto";

export class ProductDtoBase {
    id: string;
    priceExVat: number;
    name: string;
    description: string;
    currencyCode: string;
    imageUrl: string;
    productType: ProductType;
    productionMaterialType: ProductionMaterialType;
    drawableObjectId: string | null;
    drawableObject: DrawableObjectDto;
    textureMaterialId: string | null;
    textureMaterial: TextureMaterialDto;
    clientConfigurationId: string;
    index: number;
}
